export var Confidence;
(function (Confidence) {
    Confidence["Present"] = "present";
    Confidence["Possible"] = "possible";
    Confidence["NeedsReview"] = "needs_review";
    Confidence["NotDetected"] = "not_detected";
})(Confidence || (Confidence = {}));
//# sourceMappingURL=detection.js.map